// Shared transform, should take in a set of dealers, turn them into something more coherent, and return them
// taken from dealer-panel.js
// todo: use markerPath ?
// dealer.common.tmpl.js?
define('lib/transforms/dealer.tmpl.common',[
  'jquery',
  'lib/zeroBasedDay',
  'lib/util/tda.config',
  'lib/readable-monetize'
], function (
  $,
  zeroBasedDay,
  tdaConfig,
  readableMonetize
) {
  function __getTDACodeFromDealerLocatorResult(dealerLocatorResult) {
    var organizationGrepResults = [];
    var organization;
    var party;
    var tdaCode;

    if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.organization) {
      organizationGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.organization, function (element, index) {
        // return the organization with type TDA
        if (element.organizationType) return element.organizationType.value == 'TDA';
      });

      if (organizationGrepResults.length) {
        organization = organizationGrepResults[0];

        if (organization.party.length) {
          party = organization.party[0];

          if (party.specifiedOrganization && party.specifiedOrganization.companyCode) {
            tdaCode = party.specifiedOrganization.companyCode.value;
          }
        }
      }
    }
    return tdaCode;
  }

  function __isDealerLocatorResultPMA(dealerLocatorResult) {
    var programGrepResults = [];
    var program;
    var isPMA;

    if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.program) {
      programGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.program, function (element, index) {
        // return the program with code TDA
        if (element.code) return element.code.value === 'PMA';
      });

      if (programGrepResults.length) {
        program = programGrepResults[0];
        if (typeof program.participationIndicator === 'undefined') {
          isPma = false;
        } else {
          isPMA = program.participationIndicator;
        }
      } else {
        isPMA = false;
      }
    }
    return isPMA;
  }

  function __isDealerLocatorResultMirai(dealerLocatorResult) {
    var programGrepResults = [];
    var program;
    var isMirai;

    if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.additionalService) {
      programGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.additionalService, function (element, index) {
        // return the additionalService with code TDA
        if (element.code) return element.code.value == 'MiraiSales';
      });

      if (programGrepResults.length) {
        program = programGrepResults[0];
        isMirai = program.participationIndicator;
      }
    }

    if (window.location.pathname.indexOf('dealer-directory') != -1) {
      $('#search-more-dealers').hide();
    }
    return isMirai;
  };

  function __phoneNumber(val) {
    if (val != null) {
      return val.replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, '($1) $2-$3');
    }
    return val;
  }

  function __formatPhoneLink(pn) {
    var newPn = pn.replace(/[^0-9]/g, '');
    if (newPn.charAt(0) !== '1') {
      newPn = '1' + pn;
    }
    return newPn;
  }

  function __formatTime(val) {
    var hours = Math.floor(val / 60);
    var ampm = (hours < 12) ? 'am' : 'pm';
    if (hours === 0) {
      hours = 12;
    } else if (hours > 12) {
      hours -= 12;
    }
    var minutes = val % 60;
    if (minutes > 0) {
      return hours + ':' + minutes + ampm;
    }
    return hours + ampm;
  }

  function __dealerHours(start, end) {
    if (start != null && end != null) {
      return __formatTime(start) + ' - ' + __formatTime(end);
    }
    return 'Contact Dealer';
  }

  // Does NOT rely on a .dealerLocator prop on searchReslts (like the old BAT way)
  // instead it expects searchResults to be the array that lives on the .dealerLocator prop
  // from the response of a batws endpoint call
  return function (searchResults) {
    var templateResults = [];
    var currentDay = zeroBasedDay;
    var currDealer;
    var phone = null;
    var start = null;
    var end = null;
    var proximity_measure = null;
    var detailUrlPrefix = ''; // [CAT-357] Prefix to detail url

    for (var i = 0; i < searchResults.length; i += 1) {
      currDealer = searchResults[i];
      // Does dealer have BAT flag
      var programs = currDealer.dealerMetaDataDetail.program;
      var bat_flag = true;
      for (var j = 0; j < programs.length; j += 1) {
        if (programs[j].code.value === 'BAT') {
          bat_flag = programs[j].participationIndicator;
          break;
        }
      }

      if (bat_flag === false) {
        continue;
      }

      try {
        phone = currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].telephoneCommunication[0].completeNumber.value;
      } catch (e) {
        console.warn('NO phone');
      }

      $.each(currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].telephoneCommunication, function (index, value) {
        if (value.channelCode.value == "bat_toll_free" && value.completeNumber.value != null && value.completeNumber.value != '') {
          phone = value.completeNumber.value;
        }
      });

      try {
        start = currDealer.dealerLocatorDetail.hoursOfOperation[0].daysOfWeek[currentDay].availabilityStartTimeMeasure.value;
      } catch (e) {
        console.warn('NO START HOURS');
      }

      try {
        end = currDealer.dealerLocatorDetail.hoursOfOperation[0].daysOfWeek[currentDay].availabilityEndTimeMeasure.value;
      } catch (e) {
        console.warn('NO END HOURS');
      }

      try {
        proximity_measure = readableMonetize(currDealer.dealerLocatorDetail.proximityMeasureGroup.proximityMeasure.value);
      } catch (e) {
        console.warn('NO PROXIMITY MEASURE');
      }

      var dealerUrl = '';
      $.each(currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.primaryContact[0].uricommunication, function (index, value) {
        if (value.channelCode.value === 'Website') {
          dealerUrl = value.uriid.value;
        }
      });

      var brand = currDealer.dealerLocatorDetail.dealerParty.relationshipTypeCode.value;

      // [CAT-357] National needs to render GOTO URLS for dealer-detail links
      var tdaCode = __getTDACodeFromDealerLocatorResult(currDealer);
      if (tdaConfig.tda.code === 'WWW') {
        detailUrlPrefix = '/GOTO/' + tdaCode;
      }

      templateResults.push({
        dealerCode: currDealer.dealerId,
        tdaCode: tdaCode,
        dealerDetailUrlPrefix: detailUrlPrefix,
        isPma: __isDealerLocatorResultPMA(currDealer),
        isMirai: __isDealerLocatorResultMirai(currDealer),
        brand: brand.toLowerCase(),
        name: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value,
        postalAddress: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.lineOne.value,
        city: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.cityName.value,
        state: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value,
        zipCode: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.postcode.value,
        phone: __phoneNumber(phone),
        phoneLink: __formatPhoneLink(phone),
        hours: __dealerHours(start, end),
        siteUrl: dealerUrl,
        coords: {
          lat: currDealer.dealerLocatorDetail.proximityMeasureGroup.geographicalCoordinate.latitudeMeasure.value,
          lon: currDealer.dealerLocatorDetail.proximityMeasureGroup.geographicalCoordinate.longitudeMeasure.value
        },
        proximityMeasure: proximity_measure,
        dataLayer: {
          dealer_brand: brand.toLowerCase(),
          dealer_code: currDealer.dealerId,
          dealer_name: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.companyName.value,
          dealer_zipcode: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.postcode.value,
          dealer_city: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.cityName.value,
          dealer_state: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.postalAddress.stateOrProvinceCountrySubDivisionID.value,
          dealer_metro: currDealer.dealerLocatorDetail.dealerParty.specifiedOrganization.divisionCode.name,
          link_text: 'DealerClick'
        },
        raw: currDealer
      });
    }
    return templateResults;
  };
});

